import React from 'react';
import { usePreventDoubleClick } from '../hooks/usePreventDoubleClick';
import { exibirErro, exibirSucesso } from '../../util/notificacoes';
import styles from './Formulario.module.css'; // opcional, para mensagens e layout

function Formulario({ onSubmit, children, className = '' }) {
    const [safeSubmit] = usePreventDoubleClick(async (e) => {
        e.preventDefault();

        try {
            const resultado = await onSubmit();
            if (resultado) exibirSucesso(resultado);
        } catch (err) {
            exibirErro(err.message || 'Erro ao enviar o formulário.');
        }
    });

    return (
        <form onSubmit={safeSubmit} className={className}>
            {children}
        </form>
    );
}

export default Formulario;
